<template>
  <div class="footer-information">
    <h3 class="footer-information-title">
      <span>{{ messages.eShopContacts }}</span>
    </h3>
    <div class="footer-phones">
      <div class="footer-phones__item">
        <span class="footer-phones__title">{{ messages.eShopPhone }}</span>
        <a :href="'tel:' + result.eShopPhone" class="footer-phones__phone">{{
          result.eShopPhone
        }}</a>
      </div>
      <div class="footer-phones__item">
        <span class="footer-phones__title">{{ messages.eShopServicePhone }}</span>
        <a :href="'tel:' + result.eShopServicePhone" class="footer-phones__phone">{{
          result.eShopServicePhone
        }}</a>
      </div>
    </div>
    <div class="footer-email">
      <span class="footer-email__title">Email:</span>
      <a
        class="footer-email__link"
        :href="'mailto:' + result.eShopMail + '?subject=' + result.messages.eShopMailSubject"
      >
        {{ result.eShopMail }}
      </a>
    </div>
    <div class="footer-times" v-html="result.eShopTimeTable"></div>
    <DefSocial />
  </div>
</template>

<script lang="ts" setup>
import DefSocial from '@components/Def/DefSocial/DefSocial.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const resultsStore = useResultsStore();

const messages = computed(() => resultsStore?.storeInformation?.messages);
const result = computed(() => resultsStore?.storeInformation);
</script>

<style lang="scss" scoped>
.footer-information {
  :deep(.def-button-secondary) {
    width: 100%;
    margin-bottom: 16px;
    @include point-md {
      width: auto;
    }
  }
  :deep(.def-social__icon) {
    fill: #fff;
  }
  :deep(.footer-times) {
    display: grid;
    grid-row-gap: 4px;
    margin-bottom: 16px;
    @include point-md {
      margin-bottom: 20px;
    }

    .footer-times__title {
      font-size: 14px;
      font-weight: 600;
      line-height: 125%;
      color: rgba(255, 255, 255, 0.7);
    }

    .footer-times__hours {
      font-size: 16px;
      font-weight: 500;
      line-height: 125%; /* 20px */
    }
  }
}
.footer-information-title {
  font-size: 16px;
  //font-style: normal;
  font-weight: 700;
  line-height: 125%; /* 20px */
  text-transform: uppercase;
  margin-bottom: 22px;
  @include point-md {
    margin-bottom: 20px;
  }
  @include point-lg {
    font-size: 18px;
    font-weight: 600;
    line-height: 125%; /* 22.5px */
    text-transform: uppercase;
  }
}
.footer-phones {
  display: grid;
  grid-row-gap: 16px;
  margin-bottom: 16px;

  &__item {
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 4px;
  }

  &__phone {
    font-size: 16px;
    font-weight: 500;
    line-height: 125%; /* 20px */
    transition: 0.2s linear color;
    &:hover {
      color: var(--color-link-hover-dark);
    }
  }
}
.footer-email {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 4px;
  }

  &__link {
    font-size: 16px;
    font-weight: 500;
    line-height: 125%;
    transition: 0.2s linear color;
    &:hover {
      color: var(--color-link-hover-dark);
    }
  }
}
</style>
